module.exports = __webpack_public_path__ + "static/media/safari.a4a6ad69.png";